module.exports = __webpack_public_path__ + "static/img/s-vivo-1.c0bb34d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/clac/img/s-vivo-1.png
// module id = 7xdg
// module chunks = 1